var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxLogger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5852 9.72149H16.9063L14.5461 14.1801L11.8508 9.08594C12.1717 8.94322 12.4748 8.76349 12.7539 8.5504C13.0192 8.34681 13.2506 8.10266 13.4398 7.82696C13.6355 7.53773 13.7825 7.2184 13.875 6.88165C13.9801 6.49035 14.0308 6.0864 14.0254 5.68125C14.0254 5.07891 13.9223 4.54922 13.716 4.09219C13.5162 3.64364 13.2122 3.24925 12.8293 2.9418C12.4444 2.63243 11.9732 2.39805 11.4156 2.23868C10.8581 2.0793 10.2279 1.99974 9.525 2H5V14.1793H7.50937V9.72071H9.50859L12.6531 15.8606L9.50859 22H12.1871L14.5477 17.5418L16.9078 22H19.5867L16.4418 15.8606L19.5852 9.72149ZM7.50781 7.69024V4.03516H9.52344C10.1984 4.03516 10.699 4.19961 11.025 4.52852C11.351 4.85742 11.5142 5.30912 11.5145 5.8836C11.5181 6.13593 11.4756 6.38679 11.3891 6.62383C11.309 6.83882 11.1818 7.03316 11.0168 7.19259C10.8397 7.35902 10.6284 7.48474 10.3977 7.56094C10.1184 7.65217 9.82579 7.69601 9.53203 7.69063L7.50781 7.69024Z",
    fill: "#545963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxLogger);
export default __webpack_public_path__ + "static/media/rxLogger.8dc2434aec3c13b862f73c3c8bd92df3.svg";
export { ForwardRef as ReactComponent };